module.exports = __webpack_public_path__ + "img/logout.e95ba8c8.svg";